exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".banner-modal .modal-dialog{margin:auto!important;width:auto!important}.banner-modal button.close{color:#fff;width:auto;text-align:center}.banner-modal .modal-header{border:none}.banner-modal .modal-content{background:transparent!important;box-shadow:none!important;border-radius:0!important;height:100vh;width:100vw}.banner-modal .modal-body{display:-ms-flexbox;display:flex;text-align:center;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;margin:0 auto;height:100%}.banner-modal a{margin:0 auto}.banner-modal .desktop{max-width:60vw;max-height:80vh}.banner-modal .phone{display:none}@media (max-width:768px){.banner-modal .desktop{max-width:70vw;max-height:80vh}}@media only screen and (min-device-width:480px) and (max-device-width:768px) and (orientation:landscape){.banner-modal .desktop{max-height:80vh}}@media(max-width:425px){.banner-modal .desktop{display:none}.banner-modal .phone{display:block;max-width:80vw;max-height:80vh}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/ContactForm.css
// module id = 343
// module chunks = 0